module.exports = __webpack_public_path__ + "img/DeleteIconWhite.8bfdb3f1.svg";